export default {
  
  methods: {

    heroImageLoaded() {
      
      if (window['__PRERENDER_INJECTED']) {
        return;
      }
      this.heroImage = this.content.heroImage.loaded;
      this.heroImageBlur = false;
    
    }

  }
};
